'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';

import { ProductCard } from './ProductCard';

export const ProductFeedSection = () => {
  const { data } = useSuspenseQuery({
    ...UnauthQueryOptions['get:/wello/v2/allows/local-market/product-feeds'](),
  });

  const products = data?.context?.items ?? [];

  if (products.length === 0) {
    return (
      <div className="flex min-h-[240px] flex-col items-center justify-center gap-12 self-stretch py-48">
        <p className="text-center font-400 text-Gray-550 typo-body3">
          준비 중인 상품이 없어요.
          <br />곧 새로운 상품으로 찾아올게요.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-x-24 gap-y-48 self-stretch mobile-tablet:grid-cols-1 mobile-tablet:gap-48">
      {products.map((product) => (
        <ProductCard key={product.productId} product={product} />
      ))}
    </div>
  );
};
